export function appendScript(url, onload = () => {}) {
    if (url) {
        const script = document.createElement('script');
        script.src = url;
        script.onload = onload;

        document.body.appendChild(script);
    }
}

export function removeOneTrustLink() {
    const otManageLink = document.querySelector('[data-action="onetrust-manage"]');

    if (otManageLink) {
        otManageLink.remove();
    }
}
